import { api } from '@/lib/api';
import type { ApiUser, UserProfile } from '@/lib/types';

export interface UpdateProfileDto {
  displayName: string;
  bio?: string | null;
}

export async function getMyProfile(): Promise<ApiUser> {
  return api<ApiUser>('/users/me');
}

export async function updateMyProfile(dto: UpdateProfileDto): Promise<ApiUser> {
  return api<ApiUser>('/users/me', {
    method: 'PATCH',
    body: JSON.stringify(dto),
  });
}

export async function uploadAvatar(file: File): Promise<ApiUser> {
  const formData = new FormData();
  formData.append('file', file);
  return api<ApiUser>('/users/me/avatar', {
    method: 'PATCH',
    body: formData,
    // Ne pas setter Content-Type manuellement — fetch le fait pour multipart/form-data
  });
}

// ---- Annuaire des membres (page dédiée) ----

function isNetworkError(err: unknown): boolean {
  return err instanceof TypeError || (err instanceof Error && /fetch|network/i.test(err.message));
}

export async function getMemberProfiles(): Promise<UserProfile[]> {
  const result = await api<UserProfile[] | { items?: UserProfile[]; data?: UserProfile[] }>('/users');
  if (Array.isArray(result)) return result;
  if (result && 'items' in result && Array.isArray(result.items)) return result.items;
  if (result && 'data' in result && Array.isArray(result.data)) return result.data;
  return [];
}